module.exports = __webpack_public_path__ + "media/icons/paliwa-menu@3x-5044d8d6.svg";